import { MedicalExamInfo } from './medicalExamType.types';
import { Organization } from './organization';
import { Practitioner } from './practitioner';
import { PractitionerRole } from './practitionerRole';

export type DocumentTypeInfo = {
  code: string;
  label: string;
  trigram: string;
  authorized: boolean;
};

export type DocumentSpecialityInfo = {
  code: string;
  label: string;
  trigram: string;
};

export type DocumentTemplateSettings = {
  separator?: string;
  fields?: Array<{
    name: string;
    format: string;
  }>;
  autoGeneratedAtIntegration?: boolean;
};

export type DocTypeSetting = ['deactivated', 'all', string]; // TODO: Instead of string, use doc types when they will be fetched from the backend

export type ForwardToLifenDocumentMode = 'all' | 'dmp_only';

export interface ProfessionalSettings {
  lifenFeatureSetIntegrations?: {
    mssInboxActiveOption?: boolean;
    automaticIntegrationOption?: boolean;
    enableRequiredFieldsOption?: boolean;
    enableFunctionalUnitLabelsOption?: boolean;
    documentTypesSetting: DocumentTypeInfo[];
    documentSpecialitiesSetting?: DocumentSpecialityInfo[];
    medicalExamsSettings?: MedicalExamInfo[];
    enableDuplicateDetectionOption?: boolean;
    disableInAppImportOption?: boolean;
    documentTitleTemplateSetting?: DocumentTemplateSettings;
    assignedPractitionerRequiredOption?: boolean;
    collectionServiceOption?: boolean;
  };
  lifenFeatureSetPatients?: {
    activated?: boolean;
    ensSendingSetting: DocTypeSetting;
    dematSetting: DocTypeSetting;
    postalSetting: DocTypeSetting;
    automaticDematResendingSetting: DocTypeSetting;
    automaticPostalResendingSetting: DocTypeSetting;
    disableInAppImportOption?: boolean;
    ensSendingOption?: boolean;
    automaticTrustedContactsOption?: boolean;
    dematOption?: boolean;
    postalOption?: boolean;
  };
  lifenFeatureSetMedicalVisas?: {
    precheckedDocumentTypeSettings: DocumentTypeInfo[];
    attributionModeOption?: 'service' | 'doctor';
  };
  lifenFeatureSetPrivatePmsiServices?: {
    lifenDocumentForwardModeSetting: ForwardToLifenDocumentMode;
  };
}
export enum ProfessionalBaseType {
  Organization = 'Organization',
  Practitioner = 'Practitioner',
  PractitionerRole = 'PractitionerRole',
}
export interface ProfessionalDto {
  id: string;
  type: ProfessionalBaseType;
  practRolePractitionerReference?: string;
}
export interface ProfessionalBase extends ProfessionalDto {
  type: ProfessionalBaseType;
  source?: string;
  id: string;
  contactId?: number;
  contactType?: 'organization' | 'practitioner';
  userId?: string;
  name: string;
  qualifications?: string;
  status?: string;
  hasPostalContactPreference?: boolean;
  practitionerRoles?: PractitionerRole[];
  prefix?: string;
  featureSets?: ProfessionalSettings;
  isFavorite?: boolean;
}

export type Professional = Organization | Practitioner | PractitionerRole;
